<div class="meter-header-item">
  <div class="title">
    {{ title }}
  </div>

  <div class="content">
    <app-svg-icon *ngIf="contentIconSvg" class="content-icon" title="{{ meterTypeName }}" [src]="contentIconSvg"></app-svg-icon>
    <img alt="content-img" *ngIf="contentIconPng" class="content-img" [src]="contentIconPng" />

    <div class="content-text" *ngIf="!hasTooltip">
      {{ contentText }}
    </div>

    <div class="content-text" *ngIf="hasTooltip">
      <div class="text-overflow" [matTooltip]="contentText" appMatTooltipOnEllipsis>
        {{ contentText }}
      </div>
    </div>
  </div>
</div>
